import React, { useState } from "react";
import { Button, Divider, ListItemIcon, ListSubheader, Menu, MenuItem } from "@mui/material";
import { RiCheckboxCircleLine, RiEditLine, RiMoreFill, RiProhibitedLine, RiWalletLine } from "@remixicon/react";
import { tokens } from "../../utils/figmaTokens";

// The ⋯ menu's icon for the dialog an item opens.
const menuIcon = (dialog, disabled) =>
  dialog === "edit" ? RiEditLine : dialog === "adjust" ? RiWalletLine : disabled ? RiCheckboxCircleLine : RiProhibitedLine;

// The page head's ⋯ (047 D14), shared by the student and the tutor page: "Account actions" over
// `items` (studentDetail.studentMenuItems), the account action set apart by a line as Figma's
// menu does. `disabled` is the person's, for the Enable / Disable icon; `onPick(dialog)` opens
// the page's dialog. No items, no button.
const AccountMenu = ({ items, disabled, onPick }) => {
  const [anchor, setAnchor] = useState(null);
  if (items.length === 0) return null;

  const rows = items.flatMap((item, i) => {
    const Icon = menuIcon(item.dialog, disabled);
    const row = (
      <MenuItem
        key={item.label}
        onClick={() => {
          setAnchor(null);
          onPick(item.dialog);
        }}
        sx={item.danger ? { color: tokens.error.ink } : undefined}
      >
        <ListItemIcon sx={{ color: "inherit" }}>
          <Icon size={16} />
        </ListItemIcon>
        {item.label}
      </MenuItem>
    );
    return item.dialog === "disable" && i > 0
      ? [<Divider key="divider" sx={{ "&&": { my: "4px" }, borderColor: tokens.border.default }} />, row]
      : [row];
  });

  return (
    <>
      <Button
        size="large"
        variant="outlined"
        aria-label="More actions"
        aria-haspopup="menu"
        aria-expanded={Boolean(anchor)}
        onClick={(e) => setAnchor(e.currentTarget)}
      >
        <RiMoreFill size={20} />
      </Button>
      <Menu
        anchorEl={anchor}
        open={!!anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { sx: { width: 252, mt: "4px" } } }}
      >
        {[
          <ListSubheader
            key="caption"
            disableSticky
            sx={{ typography: "labelCaption", bgcolor: "transparent", color: tokens.text.tertiary, px: "10px", pt: "6px", pb: "4px" }}
          >
            Account actions
          </ListSubheader>,
          ...rows,
        ]}
      </Menu>
    </>
  );
};

export default AccountMenu;
